module.exports = __webpack_public_path__ + "img/INTERNAL.3687345c.png";